import { Mic, ArrowRight, UserPlus } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

const GUESTS = [
  "Hospital Directors",
  "Doctors",
  "Healthcare Administrators",
  "Healthcare Entrepreneurs",
  "Healthcare Professionals",
  "Insurance & TPA Professionals",
  "Healthcare Experts",
];

export const Connect = () => (
  <section id="connect" className="relative overflow-hidden bg-[#EAF3F8] py-24 sm:py-32">
    <div className="pointer-events-none absolute -left-32 bottom-0 h-[380px] w-[380px] rounded-full bg-[#5FA832]/5 blur-[110px]" />
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-7">
        <Reveal>
          <SectionTag index="08" label="Healthcare Connect" />
          <h2 className="font-display mt-6 text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
            Healthcare Solutions Connect
          </h2>
          <p className="font-display mt-3 text-lg text-[#5FA832]">Conversations That Shape Healthcare</p>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#4A6B82]">
            Healthcare grows when people connect, share knowledge and learn from one another.
            Healthcare Solutions Connect is our platform for conversations with people working
            across the healthcare ecosystem. Through interviews, conversations and industry
            discussions, we aim to bring useful healthcare perspectives to a wider audience.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <p className="font-mono-x mt-8 text-[11px] uppercase tracking-[0.3em] text-[#4C8F2F]">Featuring:</p>
          <div className="mt-4 flex flex-wrap gap-2.5">
            {GUESTS.map((g) => (
              <span
                key={g}
                className="rounded-full border border-[#0B3C5C]/15 bg-[#0B3C5C]/[0.04] px-4 py-2 text-xs font-medium text-[#33586F] transition-colors duration-300 hover:border-teal-500/40 hover:text-[#5FA832]"
              >
                {g}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="/connect"
              data-testid="connect-cta-explore"
              className="group inline-flex items-center gap-2 rounded-full bg-[#5FA832] px-8 py-4 text-sm font-bold text-white transition-all duration-300 hover:bg-[#4C8F2F]"
            >
              Explore Healthcare Connect
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <a
              href="#enquiry"
              data-testid="connect-cta-guest"
              className="inline-flex items-center gap-2 rounded-full border border-[#0B3C5C]/40 px-8 py-4 text-sm font-semibold text-[#33586F] transition-all duration-300 hover:border-amber-500/60 hover:text-amber-400"
            >
              <UserPlus className="h-4 w-4" />
              Become a Featured Guest
            </a>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="lg:col-span-5">
        <div className="spotlight-frame relative">
          <div className="overflow-hidden rounded-[2rem] border border-[#0B3C5C]/15 shadow-2xl shadow-black/40">
            <img
              src={IMAGES.doctorsXray}
              alt="Doctors discussing healthcare insights"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-white/85 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 flex items-center gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#5FA832] shadow-lg shadow-teal-500/30">
                <Mic className="h-5 w-5 text-white" />
              </span>
              <div>
                <p className="font-display text-sm font-bold text-[#0B3C5C]">Healthcare Connect Series</p>
                <p className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-[#5FA832]">Interviews · Coming Soon</p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
